const vendorPrefix = require("vendor-prefix");
module.exports = vendorPrefix("pointer-events");
